import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';

import routeTo from '../utils/routeTo';

export const useRequiredLoginFields = candidate => {
  const history = useHistory();

  const missingRequiredLoginFields = candidate?.missingRequiredLoginFields || [];

  const hasMissingFields = missingRequiredLoginFields.length > 0;

  useEffect(() => {
    if (hasMissingFields) {
      history.push(routeTo('required.requiredLoginFields'));
    }
  }, [hasMissingFields]);

  return hasMissingFields;
};
